<div class="container-fluid login-page-bg">
  <div class="row d-flex justify-content-center align-items-center m-0" style="height: 100vh;">
    
    <div class="login-card p-5">
      <form [formGroup]="loginForm" (ngSubmit)="submit()" id="login" autocomplete="off">
        
        <!-- Logo e Texto -->
        <div class="text-center mb-4">
          <img src="../../assets/logo.png" alt="Logo" class="img-fluid mb-4" style="max-width: 220px;">
          <p class="text-muted" style="font-size: 0.9rem;">Acesse sua conta para continuar</p>
        </div>

        <!-- Input Usuário -->
        <div class="mb-3">
          <input type="text" appUppercaseInput class="form-control custom-input" [formGroup]="loginForm" formControlName="username" placeholder="Usuário">
        </div>

        <!-- Input Senha (mantive o ícone de visualizar senha à direita por boa prática de UX) -->
        <div class="input-group mb-4">
          <input [formGroup]="loginForm" formControlName="password" name="password" [type]="visibilityPassword ? 'text' : 'password'" class="form-control custom-input border-end-0" id="password" placeholder="Senha" required="true">
          <span class="input-group-text bg-white border-start-0 custom-icon-wrapper">
            <i class="fas fa-eye text-muted" style="cursor: pointer;" (click)="viewPassword()" *ngIf="!visibilityPassword"></i>
            <i class="fas fa-eye-slash text-muted" style="cursor: pointer;" (click)="viewPassword()" *ngIf="visibilityPassword"></i>
          </span>
        </div>

        <!-- Botão Entrar -->
        <div class="d-grid">
          <button class="btn custom-btn-black" type="submit" name="signin">Entrar</button>
        </div>

        <!-- Versão (mantida discreta no rodapé) -->
        <div class="text-center mt-4">
          <small class="text-muted" style="font-size: 0.75rem;">Versão do Sistema: {{ versaoApp }}</small>
        </div>

      </form>
    </div>
    
  </div>
</div>

<app-loading *ngIf="loading"></app-loading>